interface TooltipProps {
  id? : string
  content?: string
}

const TooltipIcon: React.FC<TooltipProps> = ({ id, content }) => {
  return (
    <span className='size-[18px] md:size-5 mx-3 shrink-0 cursor-pointer inline-flex align-middle justify-center items-center rounded-full text-xs font-[var(--font-weight-bold)] text-white bg-[var(--brand-1)]' data-tooltip-id={id} data-tooltip-content={content}>?</span>
  )
}

export { TooltipIcon }